import { FC } from 'react';
import { Badge } from '@salecycle/ui-component-library';
import { Helpers, LifeCycle } from 'entities/lifecycle';
import { campaignActivityStatesConfig } from '../utils/campaignActivityStatesConfig';
import { useTranslation } from 'react-i18next';

interface IProps {
  lifeCycle: LifeCycle;
}

export const StateBadge: FC<IProps> = ({ lifeCycle }) => {
  const { t } = useTranslation('campaigns');
  if (!lifeCycle) {
    return null;
  }

  const badgeProps = campaignActivityStatesConfig(t)[Helpers.getActivityState(lifeCycle)];
  return <Badge color={badgeProps?.color}>{badgeProps?.text}</Badge>;
};

export default StateBadge;
